import React from "react";
import { makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import sowmyaImg from "../Images/ProfilePic.jpg";
import calmImg from "../Images/calm.jpg";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    backgroundImage: `url(${calmImg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "clamp(1.5rem, 4vw, 3rem) 1.25rem",
    color: "darkblue",
    //textShadow: "0 0 8px rgba(0,0,0,0.7)",
  },
  heading: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: "1rem",
  },
  subText: {
    fontSize: "clamp(1rem, 2vw, 1.25rem)",
    lineHeight: 1.65,
    maxWidth: "760px",
    marginBottom: "1rem",
  },
  disclaimer: {
    fontSize: "0.9rem",
    marginBottom: "2rem",
  },
  navLinks: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "clamp(0.75rem, 2vw, 1.75rem)",
    marginBottom: "1.5rem",
  },
  link: {
    textDecoration: "none",
    color: "firebrick",
    fontSize: "1rem",
    fontWeight: "bold",
    "&:hover": {
      color: "#c8e6c9",
      borderBottom: "2px solid #c8e6c9",
    },
  },
  image: {
    width: "min(50%, 360px)",
    height: "auto",
    maxWidth: "100%",
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
    marginTop: "1rem",
  },
  "@media (max-width: 600px)": {
    heroSection: {
      padding: "1.5rem 1rem",
    },
    navLinks: {
      gap: "0.5rem 1rem",
    },
    link: {
      fontSize: "0.9rem",
    },
    image: {
      width: "min(76%, 280px)",
      borderRadius: "12px",
    },
  },
}));

function HeroLanding() {
  const classes = useStyles();

  return (
    <section className={classes.heroSection}>
      <h1 className={classes.heading}>
        Improve your Health and Wellness with Authentic Yoga and Meditation
      </h1>
      <p className={classes.subText}>
        <b>Sowmya Kadaveru</b> - A passionate teacher, volunteer, community
        leader, and wellness ambassador with the Art of Living Foundation in
        London, ON, Canada.
      </p>
      <p className={classes.disclaimer}>
        *This site is independently created and not an official Art of Living
        page.*
      </p>

      <div className={classes.navLinks}>
        <Link to="/" className={classes.link}>
          Home
        </Link>
        <a href="#testimonials-section" className={classes.link}>
          Shared Experiences
        </a>
        {/* <a href="#aboutsowmya-section" className={classes.link}>
          About Sowmya
        </a> */}
        <a href="#Workshops-section" className={classes.link}>
          Free Weekly Sessions
        </a>
        <a href="#contact-section" className={classes.link}>
          Contact Info
        </a>
      </div>

      <img src={sowmyaImg} alt="Sowmya Kadaveru" className={classes.image} />
    </section>
  );
}

export default HeroLanding;
